<template>
    <div>
        <form-header v-if="opt == 'create'" :page-name="pageName"></form-header>
        <form-header v-else :page-name="pageName" do-cust @cust="backPage"></form-header>
        <div class="container">
            <div class="card mb-2">
                <div class="card-body">

                    <!-- 所属会社選択 -->
                    <form-input ref="user_group" ip-type="inputmodal" :errs-nm="['user_group', 'user_group_nm']"
                        lab="所属会社" dft2="-- 選択 --" required @user_group_modal_open="companyModalOpen"></form-input>

                    <!-- 所属関係 -->
                    <form-input ref="relation_cmp" ip-type="select" :errs-nm="['relation_cmp']" :s-opt="relationCmpList" val-nm="val" 
                                lab-nm="lab" lab="所属関係" :required="relatRequired"></form-input>

                    <!-- ニックネーム -->
                    <form-input ref="name" :errs-nm="['name']" lab="ニックネーム" plhd="例：ぷろめい 太郎 => PT" 
                        required upunder :max-length="20" @name_blur="nameUniqueCheck"></form-input>

                    <form-input ip-type="comment" py0>
                        <i class="fas fa-info-circle"></i>
                        <span class="let-space-1">
                            イニシャル（または姓）のみにしてください。
                        </span>
                    </form-input>

                    <!-- 性別 -->
                    <form-input ref="gender" ip-type="gender" :errs-nm="['gender']" lab="性別" required></form-input>

                    <!-- 年齢 -->
                    <form-input ref="age" ip-type="select" :errs-nm="['age']" :s-opt="ageList" val-nm="val"
                                lab-nm="lab" lab="年齢" required numeric :max-length="2"></form-input>

                    <!-- 経験年数 -->
                    <form-input ref="exper" ip-type="select" :errs-nm="['exper']" :s-opt="experList" val-nm="val"
                                lab-nm="lab" lab="経験年数"></form-input>

                    <!-- 国籍 -->
                    <form-input ref="country" :errs-nm="['country']" lab="国籍" plhd="例：日本" required :max-length="20"></form-input>

                    <!-- 稼働開始 -->
                    <form-input ref="work_start_date" ip-type="select" :errs-nm="['work_start_date']" :s-opt="workStartDateList" val-nm="val"
                                lab-nm="lab" dft="100099" lab="稼働開始" required></form-input>

                    <!-- 最寄り駅 -->
                    <form-input ref="nearest_station" :errs-nm="['nearest_station']" lab="最寄り駅" plhd="例：品川駅" required :max-length="20"></form-input>

                    <!-- 希望単価(start) -->
                    <form-input ref="price_start" ip-type="select" :errs-nm="['hope_price_start']" :s-opt="priceList" val-nm="val"
                                lab-nm="lab" lab="希望単価(start)" required numeric :max-length="3" @hope_price_startChange="priceStartChange"></form-input>

                    <!-- 希望単価(end) -->
                    <form-input ref="price_end" ip-type="select" :errs-nm="['hope_price_end']" :s-opt="priceList" val-nm="val"
                                lab-nm="lab" lab="希望単価(end)" required numeric :max-length="3" @hope_price_endChange="priceEndChange"></form-input>

                    <!-- 日本語レベル -->
                    <form-input ref="jpLevel" ip-type="select" :errs-nm="['jp_level']" :s-opt="jpList" val-nm="val"
                                lab-nm="lab" dft="0" lab="日本語レベル" required numeric :max-length="1"></form-input>

                    <!-- 英語レベル -->
                    <form-input ref="enLevel" ip-type="select" :errs-nm="['en_level']" :s-opt="enList" val-nm="val"
                                lab-nm="lab" lab="英語レベル" numeric :max-length="1"></form-input>

                    <!-- スキル -->
                    <form-input ref="skill" ip-type="textarea" :errs-nm="['skill']" lab="スキル" :row="2" 
                                plhd="必要に応じて記入してくさだい。" :max-length="500" has-len></form-input>

                    <!-- 希望 -->
                    <form-input ref="hope" ip-type="textarea" :errs-nm="['hope']" lab="希望" :row="2" 
                                plhd="必要に応じて記入してくさだい。" :max-length="500" has-len></form-input>

                    <!-- 備考 -->
                    <form-input ref="note" ip-type="textarea" :errs-nm="['note']" lab="備考" :row="5" 
                                plhd="必要に応じて記入してくさだい。" :max-length="2000" has-len></form-input>
                            
                    <hr>
                    <div class="text-center text-danger">
                        <p>=== 非公開内容 ===</p>
                    </div>

                    <!-- 最新受信日 -->
                    <form-input ref="recent_in_day" ip-type="select" :errs-nm="['recent_in_day']" :s-opt="recentInDayList" val-nm="val"
                                lab-nm="lab" :dft="recentInDayDefault" lab="最新受信日" required></form-input>

                    <!-- 紹介文 -->
                    <form-input ref="summary" ip-type="textarea" :errs-nm="['summary']" lab="紹介文" :row="5" 
                                plhd="必要に応じて記入してくさだい。" :max-length="2000" has-len></form-input>

                    <!-- 紹介文title(提案用) -->
                    <form-input ref="summary_title" ip-type="textarea" :errs-nm="['summary_title']" lab="紹介文title(提案用)" :row="2" 
                                :has-trim="false" :no-blank="false" plhd="必要に応じて記入してくさだい。" :max-length="500" has-len></form-input>

                    <form-input ip-type="comment" py0>
                        <i class="fas fa-info-circle"></i>
                        <span class="let-space-1">
                            例：{{titleHintTxt}}
                        </span>
                        <span>
                            <a href="#" @click.prevent="quickInputTitle">選択</a>
                        </span>
                    </form-input>

                    <!-- 紹介文(提案用) -->
                    <form-input ref="summary_sys" ip-type="textarea" :errs-nm="['summary_sys']" lab="紹介文(提案用)" :row="5" 
                                plhd="必要に応じて記入してくさだい。" :max-length="2000" has-len></form-input>

                    <!-- システム備考 -->
                    <form-input ref="sys_note" ip-type="textarea" :errs-nm="['sys_note']" lab="システム備考" :row="5" 
                                plhd="必要に応じて記入してくさだい。" :max-length="2000" has-len></form-input>


                    <!-- 会社選択 -->
                    <select-company ref="selectCompany" :list="companys"></select-company>

                    <div class="card mb-2 mt-5">
                        <div class="card-body">
                            <div class="row form-group justify-content-center mb-0">
                                <div class="col-sm-3 mb-2">
                                    <button class="btn btn-success btn-block btn-lg" @click="dataCheck" :disabled="btnDisable">
                                        <i class="fas fa-eye"></i>&nbsp;確認画面へ
                                    </button>
                                </div>
                                <div class="col-sm-3 mb-2">
                                    <button class="btn btn-secondary btn-block btn-lg" @click="makeSummary">
                                        提案情報生成
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from 'pages/commons/form/Input'
    import FormHeader from 'pages/commons/header/Header'
    import SelectCompany from 'pages/commons/modal/selectCompany/SelectCompany'

    import {mapGetters} from 'vuex'

    export default {
        props: {
            opt: String
        },
        components: {
            FormInput,
            FormHeader,
            SelectCompany,
        },
        data () {
            return {
                companys: [],
                relationCmpList: this.makeRelationCmpList(),
                experList: this.makeExperList(),
                workStartDateList: this.makeWorkStartDateList(),
                ageList: this.makeAgeList(),
                recentInDayList: this.makeRecentInDayList(),
                priceStartInit: "",
                priceEndInit: "",
                priceList: this.makePriceList(),
                jpList: this.makeJpList(),
                enList: this.makeEnList(),
                reqForm: {},
                resultArr: [],
                formArr:[
                        'user_group'
                        ,'relation_cmp'
                        ,'name'
                        ,'gender'
                        ,'age'
                        ,'exper'
                        ,'country'
                        ,'work_start_date'
                        ,'nearest_station'
                        ,'price_start'
                        ,'price_end'
                        ,'jpLevel'
                        ,'enLevel'
                        ,'skill'
                        ,'hope'
                        ,'note'
                        ,'recent_in_day'
                        ,'summary'
                        ,'summary_title'
                        ,'summary_sys'
                        ,'sys_note'
                    ],
                uniqueId: null,
                btnDisable: false,
                errStyle: {
                    border: '1px solid #f7c6c5',
                    color: '#761b18',
                },
                titleHintTxt: this.makeTitleHint(),
                recentInDayDefault: this.$moment(new Date).format('YYYYMMDD'),
                relatRequired: true,
                makedSummary:'',
            }
        },
        watch: {
            getResumeInfo (info) {
                if (info.data.resume) {
                    this.setDefaultVal(info.data.resume)
                }
                this.companys = info.data.companys
            },
            getUniqueCheckStatus (status) {
                if (status == 2) {
                    if (this.getUniqueCheckErr.err) {
                        this.btnDisable = true
                        this.$refs.name.setErrs(this.getUniqueCheckErr.err)
                        this.$refs.name.setStyle(this.errStyle)
                    } else {
                        this.btnDisable = false
                        this.$refs.name.clearErrs()
                        this.$refs.name.setStyle({})
                    }
                }
            }
        },
        computed: {
            pageName () {
                return this.opt == 'create' ? "履歴情報入力" : "履歴情報編集"
            },
            ...mapGetters(['getResumeInfo', 'getUniqueCheckStatus', 'getUniqueCheckErr'])
        },
        methods: {
            backPage () {
                this.$parent.changeOperat('show')
            },
            setDefaultVal (info) {
                // 編集ボダン押下
                this.$refs.user_group.setInputData(info.user_group, info.user_group_nm)
                this.$refs.relation_cmp.setInputData(info.relation_cmp)
                if (info.user_group == 'none') {
                    this.$refs.user_group.setDisabled(true)
                }
                this.relationSet(info.user_group)
                this.$refs.name.setInputData(info.name)
                this.$refs.gender.setInputData(info.gender)
                this.$refs.age.setInputData(info.age)
                if (info.exper) {
                    this.$refs.exper.setInputData(info.exper)
                }
                this.$refs.country.setInputData(info.country)

                if (!this.$parent.isOverStart(info.work_start_date)) {
                    this.$refs.work_start_date.setInputData(info.work_start_date)
                }
                if (info.nearest_station) {
                    this.$refs.nearest_station.setInputData(info.nearest_station)
                }
                this.$refs.price_start.setInputData(info.hope_price_start)
                this.$refs.price_end.setInputData(info.hope_price_end)
                this.$refs.jpLevel.setInputData(info.jp_level)
                if (info.en_level) {
                    this.$refs.enLevel.setInputData(info.en_level)
                }
                if (info.skill) {
                    this.$refs.skill.setInputData(info.skill)
                }
                if (info.hope) {
                    this.$refs.hope.setInputData(info.hope)
                }
                if (info.note) {
                    this.$refs.note.setInputData(info.note)
                }
                if (!this.isOverRecentInDayList(info.recent_in_day)) {
                    this.$refs.recent_in_day.setInputData(info.recent_in_day)
                }
                if (info.summary) {
                    this.$refs.summary.setInputData(info.summary)
                }
                if (info.summary_title) {
                    this.$refs.summary_title.setInputData(info.summary_title)
                }
                if (info.summary_sys) {
                    this.$refs.summary_sys.setInputData(info.summary_sys)
                }
                if (info.sys_note) {
                    this.$refs.sys_note.setInputData(info.sys_note)
                }
                // uniqueチェック用
                this.uniqueId = info.id ? info.id : null
            },
            getChildData () {
                this.formArr.forEach(item => {
                    var formData = this.$refs[item].getData()
                    this.reqForm = Object.assign({},this.reqForm, formData)
                })
            },
            getData() {
                return this.reqForm
            },
            dataCheck () {

                  /** test 用start **/
               // this.getChildData()
               // this.$parent.getChildData()
               // this.$parent.changeOperat('auto')
                  /** test 用end **/

                this.checkForm()
                this.doDataCheck ()
            },
            doDataCheck () {
                Promise.all(this.resultArr)
                    .then((res) => {
                        this.getChildData()
                        this.$parent.getChildData()
                        this.$parent.changeOperat('auto')
                    })
            },
            checkForm () {
                this.resultArr = []
                this.formArr.forEach(formName => {
                    this.doCheckForm(formName)
                })
            },
            doCheckForm (formName) {
                var result = new Promise((resolve, reject) => {

                    let valid = this.$refs[formName].dataCheck()           
                    if (valid) { 
                        resolve() }
                })
                this.resultArr.push(result)
            },
            priceStartChange (val) {
                let obj_end = this.$refs.price_end.getData()
                let end = obj_end['hope_price_end']
                if (val > end && end) {
                    this.$parent.openMsg('希望単価(start)には希望単価(end)より小さい金額を指定してください。', 1)
                    this.$refs.price_start.setInputData(this.priceStartInit)
                } else {
                    this.priceStartInit = val
                }
            },
            priceEndChange (val) {
                let obj_start = this.$refs.price_start.getData()
                let start = obj_start['hope_price_start']
                if (val < start && start) {
                    this.$parent.openMsg('希望単価(end)には希望単価(start)より大きい金額を指定してください。', 1)
                    this.$refs.price_end.setInputData(this.priceEndInit)
                } else {
                    this.priceEndInit = val
                }
            },
            nameUniqueCheck (val) {
                let opt = ""
                if (this.opt == 'create') {
                    opt = '0'
                }
                if (this.opt == 'edit') {
                    opt = '1'
                }
                this.$store.dispatch('uniqueCheck', {
                    val: val,
                    lab: 'ニックネーム',
                    table: 'teches',
                    col: 'name' , 
                    key: this.uniqueId ,
                    opt: opt 
                })
            },
            companyModalOpen () {
                if (this.opt == 'create') {
                    this.$refs.selectCompany.openThis()
                } else {
                    this.$refs.selectCompany.openThis({teOpt:true})
                }
            },
            setCompany (val) {
                if (!(val.user_group == 'none' && this.opt == 'create')) {
                    this.$refs.user_group.setInputData(val.user_group, val.name)
                }
                this.relationSet(val.user_group)
            },
            relationSet (group) {
                if (group == 'none') {
                    this.relatRequired = false
                    this.$refs.relation_cmp.setInputData("")
                    this.$refs.relation_cmp.setDisabled(true)
                } else {
                    this.relatRequired = true
                    this.$refs.relation_cmp.setDisabled(false)
                }
            },
            quickInputTitle () {
                let title = this.makeTitleHint(this.$refs.name.getData()['name'])
                this.$refs.summary_title.setInputData(title)
            },
            makeTitleHint (name="GK") {
                return "人材【即日～/COBOL/SQL】" + name + "のご紹介です。"
            },
            makeRelationCmpList () {
                return this.$parent.getList('relation_cmp')
            },
            makeExperList () {
                return this.$parent.getList('exper')
            },
            makeWorkStartDateList () {
                return this.$parent.getList('work_start_date')
            },
            makeAgeList () {
                return this.$parent.getList('age')
            },
            makePriceList () {
                return this.$parent.getList('price')
            },
            makeJpList () {
                return this.$parent.getList('jp')
            },
            makeEnList () {
                return this.$parent.getList('en')
            },
            makeRecentInDayList () {
                return this.$parent.getList('recent_in_day')
            },
            isOverRecentInDayList (val) {
                return this.$parent.getList('recent_in_day').findIndex(item => item.val == val) == -1 ? true : false
            },
            makeSummary () {
                if (this.getResumeInfo.data.resume) {
                    this.makedSummary = ''
                    this.makedSummary = this.makeSummaryDo(this.getResumeInfo.data.resume)
                    let old_sys = this.$refs.summary_sys.getData()['summary_sys']
                    if (old_sys.trim()) {
                        this.$parent.openMsg('提案用紹介文を上書きしますか？', 2)
                    } else {
                        this.setMakedSummary()
                    }
                }
            },
            setMakedSummary() {
                this.$refs.summary.setInputData(this.makedSummary)
                this.$refs.summary_sys.setInputData(this.makedSummary)
            },
            makeSummaryDo (item) {
                let str = ''
                str += `【氏　名】${item.name}（${item.gender == '0'?'男性':'女性'}　${item.age}歳）\n`
                str += `【国　籍】${item.country}\n`
                str += `【日本語】${this.converVal('jp',item.jp_level)}\n`
                str += item.en_level ? `【英　語】${this.converVal('en',item.en_level)}\n` : ''
                str += `【最寄駅】${item.nearest_station}\n`
                str += item.relation_cmp ? `【所　属】${this.converVal('relation_cmp',item.relation_cmp)}\n`:'【所　属】弊社個人事業主\n'
                str += item.exper ? `【経　験】${this.converVal('exper',item.exper)}\n`:''
                str += `【単　金】`
                if (item.hope_price_start == item.hope_price_end) {
                    str += `${item.hope_price_end}万円\n`
                } else {
                    str += `${item.hope_price_start}～${item.hope_price_end}万円\n`
                }
                str += `【稼　働】${this.converVal('work_start_date',item.work_start_date)}\n`

                str += item.skill ? `【スキル】\n${item.skill}\n` : ''
                str += item.hope ? `【希　望】\n${item.hope}\n` : ''
                str += item.note ? `【備　考】\n${item.note}\n` : ''
                return str
            },
            converVal (name,value) {
                return this.$parent.converVal(name,value)
            },


        }
    }
</script>

<style lang="stylus" scoped>
    

</style>
